module.exports = __webpack_public_path__ + "img/qualificationCash.73196ea4.png";